import store from '@/store'
import storejs from 'store'
import { isArray } from '@/utils/validate'

export function hasSelect(route, type) {
  let result = false
  const widgets = storejs.get(`${storejs.get('appId')}-widgets`) || []
  if (isArray(widgets) && widgets.length > 0) {
    let isExist
    switch (route.meta.classify) {
      case 'order': isExist = widgets.find((widget) => widget.title === '订单'); break;
      case 'display': isExist = widgets.find((widget) => widget.title === '展示'); break;
      default: isExist = ''
        break;
    }
    const showWidget = isExist && isExist.appWidget && isExist.appWidget.subMenuList || []
    return showWidget.includes(type)
  }
  return result
}

export function hasAccess(value) {
  if (store.getters['acl/admin']) return true
  if (isArray(value) && value.length > 0)
    return can(store.getters['acl/role'], {
      role: value,
      mode: 'oneOf',
    })
  const { role, ability, mode = 'oneOf' } = value
  let result = true
  if (role) result = result && can(store.getters['acl/role'], { role, mode })
  if (result && ability)
    result = can(store.getters['acl/ability'], {
      role: ability,
      mode,
    })
  return result
}

export function can(roleOrAbility, value) {
  let hasRole = false
  const { role, mode } = value
  if (role && mode) {
    if (mode === 'allOf') {
      hasRole = role.every((item) => {
        return roleOrAbility.includes(item)
      })
    }
    if (mode === 'oneOf') {
      hasRole = role.some((item) => {
        return roleOrAbility.includes(item)
      })
    }
    if (mode === 'except') {
      hasRole = !role.some((item) => {
        return roleOrAbility.includes(item)
      })
    }
  }
  return hasRole
}
